module.exports = __webpack_public_path__ + "static/media/Menu_Cross.59a9dd9e.svg";